// extracted by mini-css-extract-plugin
module.exports = {"container":"otp_container__3cTHs","otp-input":"otp_otp-input__hzxRJ"};